import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgGroupPresentation = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-.5 -.5 16 16"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {
          "\n    Group Presentation Streamline Icon: https://streamlinehq.com\n  "
        }
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path d="M4.6875 14.0625H3.75v-1.4062H1.875v1.4062H.9375v-1.4062a.9386.9386 0 0 1 .9375-.9375H3.75a.9386.9386 0 0 1 .9375.9375ZM14.0625 14.0625h-.9375v-1.4062H11.25v1.4062h-.9375v-1.4062a.9386.9386 0 0 1 .9375-.9375h1.875a.9386.9386 0 0 1 .9375.9375ZM9.375 14.0625h-.9375v-1.4062h-1.875v1.4062H5.625v-1.4062a.9386.9386 0 0 1 .9375-.9375h1.875a.9386.9386 0 0 1 .9375.9375ZM6.5625 10.3125a.9375.9375 0 1 0 1.875 0 .9375.9375 0 1 0-1.875 0M1.875 10.3125a.9375.9375 0 1 0 1.875 0 .9375.9375 0 1 0-1.875 0M11.25 10.3125a.9375.9375 0 1 0 1.875 0 .9375.9375 0 1 0-1.875 0M8.9063 8.4375a.9375.9375 0 1 0 1.875 0 .9375.9375 0 1 0-1.875 0M4.2188 8.4375a.9375.9375 0 1 0 1.875 0 .9375.9375 0 1 0-1.875 0M12.1875 6.5625h-9.375a.9386.9386 0 0 1-.9375-.9375v-3.75a.9386.9386 0 0 1 .9375-.9375h9.375a.9386.9386 0 0 1 .9375.9375v3.75a.9386.9386 0 0 1-.9375.9375M2.8125 1.875v3.75h9.375v-3.75Z" />
    <path fill="none" d="M0 0h15v15H0Z" />
  </svg>
);
export default SvgGroupPresentation;
